import {
  ApplicationRef,
  Component,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injector,
  OnInit,
} from '@angular/core';
import { ConstantsTexte } from 'src/app/immutable/constants-texte';
import { Router } from '@angular/router';
import {
  FileType,
  // FileType,
  GlobalConstantsRouting,
  GlobalConstantsStorage,
  GlobalFunctions,
  //  GlobalFunctions,
  SessionStorageService,
} from 'globales-projekt-angular';
import {
  faArrowLeft,
  faDownload,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import { Betrieb } from 'src/app/data/ws/betrieb.model';
import { MatTableDataSource } from '@angular/material/table';

import { ErgSocSo } from 'src/app/data/ws/erg-soc-so.model';
import { ErgebnisAkkordeonBetriebComponent } from 'src/app/components/blocks/akkordeon/ergebnis-akkordeon-betrieb/ergebnis-akkordeon-betrieb.component';
//import { ConstantsSonstige } from 'src/app/immutable/constants-sonstige';

import { ConstantsStorage } from 'src/app/immutable/constants-storage';
import { LogikCsv } from 'src/app/functions/logik/logik-csv.module';

import { ConstantsTableColsErgSocSo } from 'src/app/immutable/table-cols/constants-table-cols-erg-soc-so';
import { ConstantsSonstige } from 'src/app/immutable/constants-sonstige';
import { UserDatenEingabe } from 'src/app/data/user/user-daten-eingabe.model';
import { ApiService } from 'src/app/services/api.service';
import * as JSZip from 'jszip';
import { JSZipObject } from 'jszip';
import { PdfManipulation } from 'src/app/functions/pdf/pdf-manipulation.module';
//import { JSZipObject } from 'jszip';

@Component({
  selector: 'app-ergebnisse',
  templateUrl: './ergebnisse.component.html',
  styleUrls: ['./ergebnisse.component.css'],
})
export class ErgebnisseComponent implements OnInit {
  anwendungsname: string = ConstantsTexte.ANWENDUNGSNAME;
  showWaitingForDataSpinner: number = 0;
  faArrowLeft: IconDefinition = faArrowLeft;
  faDownload: IconDefinition = faDownload;

  betriebList: Betrieb[];
  logikCsv: LogikCsv;
  currentDate: Date = new Date();
  userDatenEingabe: UserDatenEingabe[];
  dataErgSocSo: MatTableDataSource<ErgSocSo> = new MatTableDataSource();
  displayedColsErgSocSo: string[] = ConstantsTableColsErgSocSo.getColumns();

  refChildAkkordeon: ComponentRef<ErgebnisAkkordeonBetriebComponent>[] = [];
  anzahlBetriebeAnzeigen: number = ConstantsSonstige.MAX_BETRIEBE_ANZEIGEN;

  constructor(
    private apiService: ApiService, 
    private router: Router,
    private cfr: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef
  ) {}

  ngOnInit(): void {
    this.showWaitingForDataSpinner++; // Gegenstück in createNewAkkordeon wegen asynchron

    this.betriebList = SessionStorageService.getItem(
      GlobalConstantsStorage.BERECHNUNGSERGEBNISSE
    );


    this.logikCsv = new LogikCsv(
      SessionStorageService.getItem(ConstantsStorage.LOGIK_CSV)
    );



    this.userDatenEingabe = SessionStorageService.getItem(
      GlobalConstantsStorage.EINGABE_DATEN
    );

    for (let entry of this.userDatenEingabe) {

     
      entry.bezeichnung = this.logikCsv.setGetBetriebsnummerPseudonymisiert(
        entry.bezeichnung
      );

    }/**/

    if (this.anzahlBetriebeAnzeigen >= this.betriebList.length)
      this.createNewAkkordeon(this.betriebList);

    this.showWaitingForDataSpinner--;
  }

  zuMainSeite() {
    this.router.navigate([GlobalConstantsRouting.MAIN]);
  }

  async createNewAkkordeon(betriebList: Betrieb[]) {
    await new Promise((f) => setTimeout(f, 1)); // Müssen der Anwendung etwas Zeit geben, dass sie mit der Initalisierung durch ist.
    let i = 0;
    for (let entry of betriebList) {
      let ergebnisAkkordeon: ComponentFactory<ErgebnisAkkordeonBetriebComponent> =
        this.cfr.resolveComponentFactory(ErgebnisAkkordeonBetriebComponent);

      let componentRef: ComponentRef<ErgebnisAkkordeonBetriebComponent> =
        ergebnisAkkordeon.create(this.injector);
      componentRef.instance.id = entry.bezeichnung;

      componentRef.instance.betrieb = entry;

      componentRef.instance.dataBetriebsgroesse = new MatTableDataSource(
        entry.ergSocSoList
      );
      componentRef.instance.dataSocMerkmale = new MatTableDataSource(
        entry.ergSocKombiList
      );
      componentRef.instance.userDatenEingabe = this.userDatenEingabe[i];

      this.refChildAkkordeon.unshift(componentRef);

      this.appRef.attachView(componentRef.hostView);
      let domElem: Node = (componentRef.hostView as EmbeddedViewRef<any>)
        .rootNodes[0] as HTMLElement;
      document.getElementById('content_daten').before(domElem);
      i++;
    }

    // await new Promise((f) => setTimeout(f, 600)); // Müssen der Anwendung etwas Zeit geben, dass auch die Grafiken korrekt aufbaut->Resize!!! In neuer Version von Chart.Js mal schauen ob immer noch gebraucht wird.
    /*
    for (let entry of this.refChildAkkordeon) {

      entry.instance.expanded= true;
    }



    this.showWaitingForDataSpinner--; // Gegenstück in ngOnInit wegen asynchron
    */
  }

  onClickDownloadKlassifizierungAlle() {
    this.showWaitingForDataSpinner++;

    this.apiService
      .postPdfBetriebe(this.userDatenEingabe)
      .subscribe(async (response: Blob) => {
        const jsZip: JSZip = new JSZip();
        let newZipFile: JSZip = new JSZip();
        let sleepFlag: number = 0;

        let betriebsnameMap: Map<string, number> = new Map<string, number>();

        jsZip.loadAsync(response).then(async (zip: JSZip) => {
          Object.values(zip.files).forEach((fileInZip: JSZipObject) => {
            sleepFlag++;
         
            let fileNameWithoutExtension: string =
              this.logikCsv.getBetriebsnummerDepseudonymisiert(
                GlobalFunctions.getFilenameWithoutExtension(fileInZip.name)
              );

           

            let fileNameWithExtension: string;

            if (betriebsnameMap.has(fileNameWithoutExtension)) {
              betriebsnameMap.set(
                fileNameWithoutExtension,
                betriebsnameMap.get(fileNameWithoutExtension) + 1
              );

              fileNameWithExtension =
                fileNameWithoutExtension +
                ' (' +
                betriebsnameMap.get(fileNameWithoutExtension) +
                ')' +
                FileType.PDF_EXT;
            } else {
              betriebsnameMap.set(fileNameWithoutExtension, 0);

              fileNameWithExtension =
                fileNameWithoutExtension + FileType.PDF_EXT;
            }

            fileInZip.async('blob').then(async (fileData: Blob) => {
              newZipFile.file(
                fileNameWithExtension,
                PdfManipulation.writeGetDepseudonimisiertesPdf(
                  fileData,
                  fileNameWithoutExtension
                ),
                { base64: true }
              );

              sleepFlag--;
            });
          });

          let sleebExitCounter: number = 0;

          do {
            if (sleepFlag == 0) break;
            else if (sleepFlag < 0) return null;

            await GlobalFunctions.sleep(250);

            if (sleebExitCounter++ == 10) return null;
          } while (true);
 

          newZipFile
            .generateAsync({ type: 'base64' })
            .then(function (response) {

              GlobalFunctions.downloadFileGeneratedZip(
                response,
                ConstantsSonstige.FILENAME_ZIP,
                FileType.ZIP_SHORT
              );
            });
          this.showWaitingForDataSpinner--;
        });
      });
  }
}
